import React from 'react';
import { TAuthority } from 'types/authority.types';
import { useIsAuthorized } from './authorized.utils';

interface AuthorizedProps {
  children: React.ReactNode;
  authority?: TAuthority[] | undefined;
  noMatch?: React.ReactNode;
}

const Authorized: React.FunctionComponent<AuthorizedProps> = ({
  children,
  authority,
  noMatch = null,
}) => {
  const isAuthorized = useIsAuthorized(authority);

  return <>{isAuthorized ? children : noMatch}</>;
};

export default Authorized;
